import Cookies from 'js-cookie'
import Reqwest from 'reqwest'
import { debug, subscribe, parseQueryString } from './utilities'
import { emitter } from './features'

export function saveEasySizeUserId (params, id) {
  if (params.shop.cookies_enabled === false) {
    return
  }

  debug('[EasySize debug]: Attempting saveEasySizeUserId', id)
  Cookies.set('esui', id, { expires: 28, secure: true, sameSite: 'strict' })
}

export function getEasySizeUserId (params) {
  const localesid = Cookies.get('esui')
  if (localesid && localesid !== '-1') {
    params.easysize.user_id = localesid
    saveEasySizeUserId(params, localesid)
  } else {
    params.easysize.user_id = params.easysize.uuid
    saveEasySizeUserId(params, params.easysize.user_id)
  }
  emitter.emit('easysize_user_id_received')
}

export function recognizeUserType (params) {
  let urlParameters = parseQueryString(window.location.href.split('?')[1])

  // If recommended product opened, identify user as returning and select size
  if (urlParameters.hasOwnProperty('es_recommended_size')) {
    params.track(32)
    let currentSize = urlParameters.es_recommended_size
    let sizeToPreselect = currentSize

    // If feature enabled, append recommended fit to predicted size
    if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
      if (params.features.append_size_with_recommended_fit === 'enabled') {
        if (urlParameters.hasOwnProperty('es_recommended_fit')) {
          sizeToPreselect = urlParameters.es_recommended_size + '/' + urlParameters.es_recommended_fit
          params.easysize.recommended_fit = urlParameters.es_recommended_fit
        }
      }
    }

    if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
      params.track(7, sizeToPreselect)
      params.track(17, params.product.stock[sizeToPreselect])
      params.easysize.user_type = 'r'
      params.easysize.calculated_size = urlParameters.es_recommended_size
      params.easysize.original_calculated_size = {
        size: urlParameters.es_recommended_size,
        predicted_fit: urlParameters.hasOwnProperty('es_recommended_fit') ? urlParameters.es_recommended_fit : '',
        better_matches: [],
        accuracy: {
          'percentage': 100.0,
          'title': 'It\'s a perfect fit!',
          'out_of_5': 5.0,
          'proven_by': 50
        }
      }
      emitter.emit('easysize-size-selected')
      emitter.emit('easysize_user_type_identified', params.easysize.user_type)
      return true
    }
  }

  if (params.features.returning_user_mode) {
    subscribe('easysize_current_user_size_calculated easysize_returning_user_size_calculated', () => {
      if (params.calculated_size.returning_user && params.calculated_size.current_user) {
        if (params.calculated_size.current_user.sizes.length > 0) {
          let sizeFound = false

          for (let i = 0; i < params.calculated_size.current_user.sizes.length; i++) {
            let currentSize = params.calculated_size.current_user.sizes[i]
            let sizeToPreselect = currentSize.size

            // If feature enabled, append recommended fit to predicted size
            if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
              if (params.features.append_size_with_recommended_fit === 'enabled') {
                if (currentSize.hasOwnProperty('recommended_fit')) {
                  sizeToPreselect = currentSize.size + '/' + currentSize.recommended_fit
                  params.easysize.recommended_fit = currentSize.recommended_fit
                }
              }
            }

            params.easysize.user_type = 'c'
            params.easysize.calculated_size_proven_by = currentSize.accuracy.proven_by
            params.easysize.calculated_size = currentSize.size
            params.easysize.original_calculated_size = currentSize

            // Sets feature to combine top / bottom recommendations
            if (currentSize.secondary_size) {
              params.easysize.calculated_size = currentSize.size + ' / ' + currentSize.secondary_size
              sizeToPreselect = currentSize.size + ' / ' + currentSize.secondary_size
            }

            if (Object.keys(params.product.fits_in_stock).length !== 0) {
              params.track(7, params.easysize.calculated_size)
              sizeFound = true
              params.track(17, params.product.fits_in_stock[currentSize.size])

              if (params.product.fits_in_stock[currentSize.size] === 0) {
                require.ensure(['./size-advisor', './size-advisor-qa'], (require) => {
                  let addSizeRecommendedText = require(`./${params.easysize.product}`).addSizeRecommendedText
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params)
                  params.track(21)
                })
              } else if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
                emitter.emit('easysize-size-selected')
              }

              break
            } else if (params.product.stock.hasOwnProperty(currentSize.size)) {
              params.track(7, params.easysize.calculated_size)
              sizeFound = true
              params.track(17, params.product.stock[currentSize.size])

              if (params.product.stock[currentSize.size] === 0) {
                require.ensure(['./size-advisor', './size-advisor-qa'], (require) => {
                  let addSizeRecommendedText = require(`./${params.easysize.product}`).addSizeRecommendedText
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params)
                  params.track(21)
                })
              } else if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
                emitter.emit('easysize-size-selected')
              }

              break
            } else if (params.features.hasOwnProperty('ignore_stock_check')) {
              // Feature to ignore stock check and call update size dropdown method anyways.
              // Tailored for shops selling one size clothing

              params.track(7, params.easysize.calculated_size)
              sizeFound = true
              if (params.product.stock.hasOwnProperty(currentSize.size)) {
                params.track(17, params.product.stock[currentSize.size])
              } else {
                params.track(21)
              }
              if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
                emitter.emit('easysize-size-selected')
              }
            }
          }

          if (!sizeFound) {
            params.track(22, params.calculated_size.current_user.sizes.map(function (el) { return el.size }).join(','))
          }
        } else if (params.calculated_size.returning_user.sizes.length > 0) {
          let sizeFound = false
          for (let i = 0; i < params.calculated_size.returning_user.sizes.length; i++) {
            let currentSize = params.calculated_size.returning_user.sizes[i]
            let sizeToPreselect = currentSize.size

            // If feature enabled, append recommended fit to predicted size
            if (params.features.hasOwnProperty('append_size_with_recommended_fit')) {
              if (params.features.append_size_with_recommended_fit === 'enabled') {
                if (currentSize.hasOwnProperty('recommended_fit')) {
                  sizeToPreselect = currentSize.size + '/' + currentSize.recommended_fit
                  params.easysize.recommended_fit = currentSize.recommended_fit
                }
              }
            }

            params.easysize.user_type = 'r'
            params.easysize.calculated_size_proven_by = currentSize.accuracy.proven_by
            params.easysize.calculated_size = currentSize.size
            params.easysize.original_calculated_size = currentSize

            // Sets feature to combine top / bottom recommendations
            if (currentSize.secondary_size) {
              params.easysize.calculated_size = currentSize.size + ' / ' + currentSize.secondary_size
              sizeToPreselect = currentSize.size + ' / ' + currentSize.secondary_size
            }

            debug('ES', 'pre logic')
            if (Object.keys(params.product.fits_in_stock).length !== 0) {
              debug('ES fits_in_stock', 7, currentSize.size)
              params.track(7, params.easysize.calculated_size)
              sizeFound = true
              params.track(17, params.product.fits_in_stock[currentSize.size])

              if (params.product.fits_in_stock[currentSize.size] === 0) {
                require.ensure(['./size-advisor', './size-advisor-qa'], (require) => {
                  let addSizeRecommendedText = require(`./${params.easysize.product}`).addSizeRecommendedText
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params)
                  params.track(21)
                })
                params.shop.update_size_dropdown(sizeToPreselect, params)
              } else if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
                emitter.emit('easysize-size-selected')
              }

              break
            } else if (params.product.stock.hasOwnProperty(currentSize.size)) {
              debug('ES stock', 7, currentSize.size)
              debug(params)
              debug(params.track)
              params.track(7, params.easysize.calculated_size)
              sizeFound = true
              params.track(17, params.product.stock[currentSize.size])

              if (params.product.stock[currentSize.size] === 0) {
                require.ensure(['./size-advisor', './size-advisor-qa'], (require) => {
                  let addSizeRecommendedText = require(`./${params.easysize.product}`).addSizeRecommendedText
                  addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params)
                  debug(params)
                  debug(params.track)
                  params.track(7, params.easysize.calculated_size)
                  params.track(21)
                })
                params.shop.update_size_dropdown(sizeToPreselect, params)
              } else if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
                emitter.emit('easysize-size-selected')
              }

              break
            } else if (params.features.hasOwnProperty('ignore_stock_check')) {
              // Feature to ignore stock check and call update size dropdown method anyways.
              // Tailored for shops selling one size clothing

              params.track(7, params.easysize.calculated_size)
              sizeFound = true
              if (params.product.stock.hasOwnProperty(currentSize.size)) {
                params.track(17, params.product.stock[currentSize.size])
              } else {
                params.track(21)
              }
              if (params.shop.update_size_dropdown(sizeToPreselect, params)) {
                emitter.emit('easysize-size-selected')
              }
            }
          }

          if (!sizeFound) {
            params.track(22, params.calculated_size.returning_user.sizes.map(function (el) { return el.size }).join(','))
          }
        }

        /*
                Brand similarity is used when this header is present.
                The response headers are saved into global variable, in order to access it after pageview id is retrieved]
                 */

        if (params.easysize.response_headers.indexOf('mse: True') !== -1 && params.easysize.response_headers.indexOf('dse: True') !== -1) {
          params.track(34, 'dse-mse')
        } else if (params.easysize.response_headers.indexOf('mse: True') !== -1) {
          params.track(34, 'mse')
        } else if (params.easysize.response_headers.indexOf('dse: True') !== -1) {
          params.track(34, 'dse')
        }

        emitter.emit('easysize_user_type_identified', params.easysize.user_type)
      }
    })

    getSizeForLoggedInUser(params, (data) => {
      if (Object.keys(params.product.fits_in_stock).length !== 0 && data.sizes.length > 0) {
        let recommendedSizeIndex = 0

        for (let i = 0; i < data.sizes.length; i++) {
          if (params.product.fits_in_stock.hasOwnProperty(data.sizes[i].recommended_fit) && params.product.fits_in_stock[data.sizes[i].recommended_fit].hasOwnProperty(data.sizes[i].size)) {
            recommendedSizeIndex = i
            break
          }
        }

        debug('Based on fits in stock', data.sizes[recommendedSizeIndex])
        params.calculated_size.current_user = {
          sizes: [data.sizes[recommendedSizeIndex]]
        }
      } else if (params.product.available_fits && params.product.available_fits.length > 0 && data.sizes.length > 0) {
        let recommendedSizeIndex = 0

        if (params.product.available_fits && data.sizes.length > 1) {
          for (let i = 0; i < data.sizes.length; i++) {
            if (params.product.available_fits.indexOf(data.sizes[i].recommended_fit) !== -1) {
              recommendedSizeIndex = i
              break
            }
          }
        }

        params.calculated_size.current_user = {
          sizes: [data.sizes[recommendedSizeIndex]]
        }
      } else {
        params.calculated_size.current_user = {
          sizes: data.sizes
        }
      }

      emitter.emit('easysize_current_user_size_calculated')
    })

    getSizeForReturningUser(params, (data) => {
      if (Object.keys(params.product.fits_in_stock).length !== 0 && data.sizes.length > 0) {
        let recommendedSizeIndex = 0

        for (let i = 0; i < data.sizes.length; i++) {
          if (params.features.check_fit_stock) {
            let s = data.sizes[i].size
            let f = false

            if (params.product.available_lengths.indexOf(data.sizes[i].recommended_length) !== -1) {
              f = data.sizes[i].recommended_length
            }

            if (params.product.available_fits.indexOf(data.sizes[i].recommended_fit) !== -1) {
              f = data.sizes[i].recommended_fit
            }

            let combined_size = params.features.check_fit_stock.replace('{s}', s).replace('{f}', f)

            if (f) {
              data.sizes[i].size = params.features.check_fit_stock.replace('{s}', s).replace('{f}', f)
              data.sizes[i].recommended_length = null
              data.sizes[i].recommended_fit = null
              recommendedSizeIndex = i
              break
            }
          } else if (params.product.fits_in_stock.hasOwnProperty(data.sizes[i].recommended_fit) && params.product.fits_in_stock[data.sizes[i].recommended_fit].hasOwnProperty(data.sizes[i].size)) {
            recommendedSizeIndex = i
            break
          }
        }

        console.log('Based on fits in stock', data.sizes[recommendedSizeIndex])
        params.calculated_size.returning_user = {
          sizes: [data.sizes[recommendedSizeIndex]]
        }
      } else if (params.product.available_fits && params.product.available_fits.length > 0 && data.sizes.length > 0) {
        let recommendedSizeIndex = 0

        if (params.product.available_fits && data.sizes.length > 1) {
          for (let i = 0; i < data.sizes.length; i++) {
            if (params.product.available_fits.indexOf(data.sizes[i].recommended_fit) !== -1) {
              recommendedSizeIndex = i
              break
            }
          }
        }

        console.log('Based on available fits', data.sizes[recommendedSizeIndex])
        params.calculated_size.returning_user = {
          sizes: [data.sizes[recommendedSizeIndex]]
        }
      } else {
        params.calculated_size.returning_user = {
          sizes: data.sizes
        }
      }

      emitter.emit('easysize_returning_user_size_calculated')
    })
  } else {
    debug('[EasySize debug]: Returning user mode disabled')
    emitter.emit('easysize_user_type_identified', params.easysize.user_type)
  }
}

function getSizeForLoggedInUser (params, callback) {
  callback({sizes: []}) // eslint-disable-line
  return
  // if (params.shop.user_id === -1) {
  //   return
  // }

  let formData = {
    'product_type': params.product.category_id,
    'product_gender': params.product.gender,
    'product_brand': params.product.brand_id,
    'sizes_in_stock': JSON.stringify(params.product.stock),
    'fit_variants': JSON.stringify(params.product.available_fits),
    'length_variants': JSON.stringify(params.product.available_lengths),
    'user_id': params.shop.user_id
  }

  if (params.product.fit_id !== -1) { formData.product_fit = params.product.fit_id }
  if (params.product.model) { formData.product_model = params.product.model }
  if (params.product.sku) { formData.product_sku = params.product.sku }

  Reqwest({
    url: `${params.easysize.api_url}${params.shop.generated_shop_id}/size/get_size_with_user/`,
    method: 'GET',
    data: formData,
    error: (resp) => {
      debug(`[EasySize debug]: Error getting size for logged in user`)
    },
    success: (resp) => {
      if (resp.status_code) {
        debug(`[EasySize debug]: EasySize size failed to calculate with [${resp.status_code}] ${resp.error}`)
      } else {
        callback(resp)
      }
    }
  })
}

function getSizeForReturningUser (params, callback) {
  let formData = {
    'product_type': params.product.category_id,
    'product_gender': params.product.gender,
    'product_brand': params.product.brand_id,
    'sizes_in_stock': JSON.stringify(params.product.stock),
    'fit_variants': JSON.stringify(params.product.available_fits),
    'length_variants': JSON.stringify(params.product.available_lengths),
    'easysize_user': params.easysize.user_id
  }

  if (params.product.fit_id !== -1) { formData.product_fit = params.product.fit_id }
  if (params.product.model) { formData.product_model = params.product.model }
  if (params.product.sku) { formData.product_sku = params.product.sku }

  let r = Reqwest({
    url: `${params.easysize.api_url}${params.shop.generated_shop_id}/size/get_size_with_orders/`,
    method: 'GET',
    data: formData,
    error: (resp) => {
      debug(`[EasySize debug]: Error getting size for returning user`)
    },
    success: (resp) => {
      if (resp.status_code) {
        debug(`[EasySize debug]: EasySize size failed to calculate with [${resp.status_code}] ${resp.error}`)
      } else {
        params.easysize.response_headers = r.request.getAllResponseHeaders()
        callback(resp)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/components/easysize-user.js